import { debounce } from "lodash";
import { useCallback, useMemo, useState } from "react";

import { useEmployeeExpectations } from "~/entity/Employee/hooks/useEmployeeExpectations";
import { EmployeeExpectation } from "~/entity/Employee/model/schema";

export interface IExpectationSelectOption {
  value: string;
  label: string;
}

export const toExpectationSelectOption = (
  item: EmployeeExpectation,
): IExpectationSelectOption => ({
  value: String(item.instanceId),
  label: (item.positions || [])
    .map((position) => `${position.code}. ${position.name}`)
    .join(", "),
});

export const useGetExpectationsForSelect = () => {
  const { expectations, loading } = useEmployeeExpectations();
  const [search, setSearch] = useState("");

  const options = useMemo(() => {
    const mapped = expectations.map(toExpectationSelectOption);

    if (!search) {
      return mapped;
    }

    const needle = search.toLowerCase();

    return mapped.filter((option) =>
      option.label.toLowerCase().includes(needle),
    );
  }, [expectations, search]);

  const onSearch = useMemo(
    () =>
      debounce((value: string) => {
        setSearch(value);
      }, 300),
    [],
  );

  const onOpenChange = useCallback((open: boolean) => {
    if (open) {
      setSearch("");
    }
  }, []);

  return { options, loading, onSearch, onOpenChange };
};
